import React from 'react';
import IntlMessages from '../../../util/IntlMessages';

const LoadError: React.FC<{ message: string; onRetry: () => void }> = ({ message, onRetry }) => (
  <div className='group-catalogue__load-error'>
    <p>{message}</p>
    <button type='button' className='jr-btn-default-outlined' onClick={onRetry}>
      <IntlMessages id='groups.catalogue.retry' />
    </button>
  </div>
);

export default LoadError;
